import * as React from 'react';
import { ConditionalWrapper } from '@cian/conditional-component';
import { ArticleHeading1, ArticleHeading3, ArticleParagraph1, Button, Image } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';

import pen from './images/pen.png';
import phone from './images/phone.png';
import scales from './images/scales.png';
import { formContextObj } from '../../containers/FormContainer';
import { NBSP } from '../../constants/symbols';
import { BigTitle } from '../BigTitle';

import * as styles from './styles.css';

export const SaleRentIntro: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isDesktop = useIsDesktop();
  const { startQuiz } = React.useContext(formContextObj);

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={BigTitle} ElseComponent={ArticleHeading1}>
          Куплю/Сниму на Циан
        </ConditionalWrapper>
      </div>
      <div className={styles['content']}>
        <div className={styles['item']}>
          <div className={styles['img']}>
            <Image src={pen} width={40} height={40} />
          </div>
          <div className={styles['item-title']}>
            <ArticleHeading3>Заполните анкету</ArticleHeading3>
          </div>
          <ArticleParagraph1>
            Это{NBSP}займет около 3{NBSP}минут, а{NBSP}мы сможем бесплатно подобрать для вас подходящих риелторов.
          </ArticleParagraph1>
        </div>
        <div className={styles['item']}>
          <div className={styles['img']}>
            <Image src={phone} width={40} height={40} />
          </div>
          <div className={styles['item-title']}>
            <ArticleHeading3>Получайте звонки</ArticleHeading3>
          </div>
          <ArticleParagraph1>
            Вам позвонят не более 3 риелторов-партнёров Циан и{NBSP}предложат свои услуги.
          </ArticleParagraph1>
        </div>
        <div className={styles['item']}>
          <div className={styles['img']}>
            <Image src={scales} width={40} height={40} />
          </div>
          <div className={styles['item-title']}>
            <ArticleHeading3>Примите решение</ArticleHeading3>
          </div>
          <ArticleParagraph1>
            Выберите понравившегося риелтора и{NBSP}договоритесь с{NBSP}ним об{NBSP}условиях работы.
          </ArticleParagraph1>
        </div>
      </div>
      <div className={styles['button-sticky']} data-testid="quizStart">
        <Button theme="fill_primary" size="M" onClick={startQuiz} fullWidth={!isDesktop}>
          Заполнить анкету
        </Button>
      </div>
    </div>
  );
};

SaleRentIntro.displayName = 'SaleRentIntro';
